<template>
    <div class="main">
        <topback title="Sell" path="back"></topback>
        <noticetop/>
        <card color="#f3f3f6">
            <div slot="card-body">
                <md-field class="assetslist">
                    <md-cell-item title="I Token" :addon="$store.state.userinfo.itoken">
                        <div class="holder" slot="left">
                        <iconimg name="i" class="assetslist-img"></iconimg>
                        </div>
                    </md-cell-item>
                </md-field>
                <div class="btngroup">
                    <div class="btnitem">
                        <iconimg name="inpaying" class="holder"></iconimg>
                        <span class="title">In transaction</span>
                        <span class="title">{{ $store.state.userinfo.inpay_quota }}</span>
                    </div>
                    <div class="btnitem">
                        <iconimg name="profit" class="holder"></iconimg>
                        <span class="title">Today Deal</span>
                        <span class="title">{{ $store.state.userinfo.today_success_amount }}</span>
                    </div>
                </div>
                <div class="btngroup">
                    <div class="btnitem">
                        <iconimg name="batch" class="holder"></iconimg>
                        <span class="title">Today times</span>
                        <span class="title">{{ $store.state.userinfo.today_assign_order }}</span>
                    </div>
                    <div class="btnitem">
                        <iconimg name="assets" class="holder"></iconimg>
                        <span class="title">Today Success</span>
                        <span class="title">{{ $store.state.userinfo.today_success_order }}</span>
                    </div>
                </div>
            </div>
        </card>
        <md-field>
            <md-cell-item title="In Sell">
                <md-switch v-model="in_sell" slot="right" @change="insell_action('in_sell', in_sell, $event)"/>
            </md-cell-item>

            <md-cell-item :title="availablect_text" brief="Active UPI KYC Partner">
                <span slot="right" @click="go_manage_kyc">
                    Manage upi kyc partner
                </span>
            </md-cell-item>

            <md-cell-item :title="availablebank_text" brief="Active Bank KYC Partner">
                <span slot="right" @click="go_manage_bankkyc">
                    Manage bank kyc partner
                </span>
            </md-cell-item>

            <md-cell-item title="Buy IToken" @click="gorouter('transaction')">
                <div class="holder" slot="left">
                    <iconimg name="i" class="assetslist-img"></iconimg>
                </div>
            </md-cell-item>

            <md-cell-item title="Sell History" arrow @click="gorouter('sellhistory')">
                <div class="holder" slot="left">
                    <iconimg name="edit" size="lg"></iconimg>
                </div>
            </md-cell-item>

            <md-cell-item title="Official Service" @click="gorouter('customerservice')" arrow>
                <div class="holder" slot="left">
                    <iconimg name="service" size="lg"></iconimg>
                </div>
            </md-cell-item>
        </md-field>
    </div>
</template>

<script>
import topback from '@/components/topback'
import navbar from '@/components/navbar'
import goodscard from '@/components/goodscard'
import pointtext from '@/components/pointtext'
import iconimg from '@/components/iconimg'
import card from '@/components/card'
import { Dialog } from 'mand-mobile'
import noticetop from '@/components/noticetop'
import { getavailablect, getavailablebank } from '@/request/api'

export default {
    name: 'sell',
    components: {
        [topback.name]: topback,
        [navbar.name]: navbar,
        [goodscard.name]: goodscard,
        [pointtext.name]: pointtext,
        iconimg,
        card,
        noticetop
    },
    data() {
        return {
            refreshuserinfointerval: "",
            availablect_count: 0,
            availablect_text: "In Active: 0",
            availablepay_text: "In Active: 0",
            refreshavailablectcountinterval: "",
            cw_workinginfo: {},
            in_sell: true,
            kyc_notline: false,
            availablebank_text: "In Active: 0",
        }
    },
    watch: {

    },
    created() {
        this.$store.dispatch("asyncupdateuserinfo").then(res=>{
            this.in_sell = res.sell;
        });
        this.$store.dispatch("asyncupdatesiteconfig");
        this.get_availablect_count();
        this.getavailablebank_count();
        let that = this;
        this.refreshuserinfointerval = setInterval(() => {
            that.$store.dispatch("asyncupdateuserinfo");
        }, 61000);

    },
    methods: {
        get_availablect_count() {
            let that = this;
            getavailablect({purpose: 'payee', payment_method: "upi"}).then(res=>{
                if(res.code === 200) {
                    this.isSelectorShow = true;
                    if(res.data.length !== 0) {
                        this.availablect_text = "In Active: " + res.data.length;
                        this.availablect_count = res.data.length;
                    } else {
                        if(that.kyc_notline) {
                            return;
                        }
                        that.kyc_notline = true;
                    }
                }
            })
        },
        getavailablebank_count() {
            getavailablebank().then(res=>{
                if(res.code === 200) {
                    this.availablebank_text = "In Active: " + res.data.available_count;
                }
            })
        },
        get_payments_count() {
            getpayments().then(res=>{
                if(res.code === 200) {
                    if(Object.keys(res.data).length !== 0) {
                        this.availablepay_text = "In Active: " + res.data.length;
                    }
                }
            })
        },
        insell_action(name, in_sell, event) {
            Dialog.confirm({
                title: 'Tips',
                content: 'For switch sell, please go to Manage kyc partner use Operating',
                cancelText: 'Cancel',
                confirmText: 'Ok',
                onConfirm: () => {
                    this.go_manage_kyc();
                },
                onCancel: () => {
                    this.in_sell = this.$store.state.userinfo.sell;
                }
            });
            this.in_sell = this.$store.state.userinfo.sell;
        },
        go_manage_kyc() {
            this.$router.push('/kycpartner')
        },
        go_manage_bankkyc() {
            this.$router.push('/banks');
        },
        gorouter(name) {
            this.$router.push({"name": name})
        }
    },
    beforeDestroy() {
        clearInterval(this.refreshuserinfointerval);
    },
    

}
</script>


<style scoped>
.noassets >>> .md-result-image {
  width: 1.6rem;
}
.noassets >>> .md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets >>> .md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
.free-text {
    color: #4a4a4a;
    font-size: 0.18rem;
    text-align: center;
}
.reward-text {
    font-size: 0.2rem;
    color: red;
}
.usdt-text {
    color: #f0b90b;
}
.payment-options {
  display: flex;
  justify-content: center;
  align-items: center;
}

.payment-options-radio {
  flex-basis: 100px;
  flex-grow: 1;
  margin: 0 10px;
}


.btnitem .title {
    font-size: 0.26rem;
    margin: 0.05rem;
}
.holder {
  line-height: 0px;
  font-size: 39px;
}

.btngroup {
  margin: 0.2rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.btngroup .holder {
  margin: 10px auto;
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.btngroup .btnitem {
  text-align: center;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: calc(90% / 3);
  height: calc(90% / 3);
  border-radius: 20px;
  box-shadow: 0 8px 12px #ebedf0;
  overflow: auto;
}
.assetslist-img {
  width: 0.42rem;
}
.assetslist .holder {
  line-height: 0px;
  font-size: 39px;
}
.assetslist-img {
  width: 0.42rem;
}

.assetslist  >>> .md-cell-item-right {
  color: black;
}
.md-card-button {
    color: #198cff;
    display: inline-block;
    padding: 0.07rem 0.07rem;
    background: #198cff;
    position: relative;
    background: 0 0;
    border-radius: 0.16rem;
    border: 3px solid #198cff;
}
.main {
    margin-top: 1rem;
}
.goodscard-group {
    background: #f3f3f6;
    margin: 10px 0;
    border-radius: 20px;
    overflow: hidden;
    padding: 20px;
}
.cell-group {
    background: #232b63;
    margin: 10px 16px;
    border-radius: 20px;
    overflow: hidden;
    padding: 20px;
}
.cell-group>>>.md-cell-item-title {
    color: #f9fafb !important;
}
.cell-group>>>.md-cell-item-body.multilines:before {
    content: none !important;
}
.header-slot{
    padding: 40px 0 20px 0;
}
.header-slot .title{
    color: #111A34;
        font-size: 60px;
        font-family: Songti SC;
        line-height: 1;
}
.header-slot .desc{
    margin-top: 16px;
        color: #858B9C;
        font-size: 26px;
}
.md-field {
    padding: 0rem 0.4rem 0 0.4rem;
}
.intrust-item {
    font-size: 0.26rem;
}
.intrust-item >>> .batch {
    color: black;
}

.intrust-item .batchd {
    margin-left: -9px;
}

.intrust-item .completion {
    margin-left: -0.19rem;
}

.intrust-item .price {
    color: black;
    font-size: 0.3rem;
}
.intrust-item .price .price-text {
    color: #2c3e50;
    font-size: 0.2rem;
}
.intrust-item .price .amount {
    font-weight: 200;
    font-size: 0.3rem;
}
.intrust-item div {
    margin: 4px;
}

.sii-gift {
    color: gold;
}
</style>


// WEBPACK FOOTER //
// src/views/my/sell.vue